import { render, staticRenderFns } from "./HealthCheck25PsaThyroidLiver.vue?vue&type=template&id=23d374ae&scoped=true&"
import script from "./HealthCheck25PsaThyroidLiver.vue?vue&type=script&lang=js&"
export * from "./HealthCheck25PsaThyroidLiver.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck25PsaThyroidLiver.vue?vue&type=style&index=0&id=23d374ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d374ae",
  null
  
)

export default component.exports